import { createReducer, on } from '@ngrx/store';
import { ChargersState } from './charger.models';
import * as chargerActions from './charger.actions';
import * as paginationConstants from '../../../shared/constants/pagination.constants';
import { ChargerUtil } from '../utils/charger.util';

export const initialChargerState: ChargersState = {
  chargers: [],
  chargersPage: null,
  chargerFilterParameters: null,
  chargerNumbers: null,
  pagination: {
    pageIndex: 0,
    pageSize: paginationConstants.DefaultPageSize,
  },
  chargerFilter: null,
  loading: false,
  error: null,
};

export const chargersReducer = createReducer(
  initialChargerState,
  on(chargerActions.loadChargerList, (state) => ({ ...state, loading: true })),
  on(chargerActions.loadChargerListFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error.errorMessage ?? 'Error',
  })),
  on(chargerActions.loadChargerListSuccess, (state, { chargersResponse }) => ({
    ...state,
    loading: false,
    error: null,
    chargers: chargersResponse.result ?? [],
    chargersPage: {
      ...state.chargersPage,
      totalCount: chargersResponse.total ?? 0,
      pageIndex: chargersResponse.pageIndex ?? 0,
      pageSize: chargersResponse.pageSize ?? 0,
    },
  })),
  on(chargerActions.saveCharger, (state) => ({ ...state, loading: true })),
  on(chargerActions.saveChargerSuccess, (state) => ({
    ...state,
    loading: false,
  })),
  on(chargerActions.saveChargerFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error?.errorMessage ?? 'Error',
  })),
  on(chargerActions.updateChargerFilter, (state, { filter }) => ({
    ...state,
    chargerFilter: filter,
  })),
  on(chargerActions.changePagination, (state, { pageIndex, pageSize }) => ({
    ...state,
    pagination: {
      pageIndex,
      pageSize,
    },
  })),
  on(chargerActions.patchChargersStatuses, (state, { statusData }) => ({
    ...state,
    chargers: ChargerUtil.updateStatuses(state.chargers, statusData),
  })),
  on(chargerActions.loadChargerNumbersByStatusSuccess, (state, { value }) => ({
    ...state,
    chargerNumbers: value,
  })),
  on(chargerActions.loadChargerFilterParameters, (state) => ({
    ...state,
    loading: true,
    chargerFilterParameters: null,
  })),
  on(
    chargerActions.loadChargerFilterParametersSuccess,
    (state, { filterParameters }) => ({
      ...state,
      loading: false,
      chargerFilterParameters: {
        ...filterParameters,
      },
    })
  ),
  on(chargerActions.loadChargerFilterParametersFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error.errorMessage ?? 'ERROR',
  }))
);
